import $ from 'jquery'

$(() => {
})
